import { SvgIcon } from '@admin/shared/components/icons/svg-icon';
import type { SvgIconComponentProps } from '@admin/shared/components/icons/svg-icon';
import { Themes, useThemeName } from '@admin/shared/themes/themes';

/**
 * Trash Icon.
 * (used in answer components)
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const TrashIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return (
      <SvgIcon name="UserlikeTrashIcon" viewBox="0 0 24 24" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 4.42896C8 3.87668 8.44772 3.42896 9 3.42896H15C15.5523 3.42896 16 3.87668 16 4.42896V6.42896H20C20.5523 6.42896 21 6.87668 21 7.42896C21 7.98124 20.5523 8.42896 20 8.42896H19L19 19C19 20.6569 17.6569 22 16 22H8.00001C6.34316 22 5.00001 20.6569 5.00001 19V8.42896H5H4C3.44772 8.42896 3 7.98124 3 7.42896C3 6.87668 3.44772 6.42896 4 6.42896H8V4.42896ZM7.00001 8.42896V19C7.00001 19.5523 7.44773 20 8.00001 20H16C16.5523 20 17 19.5523 17 19V8.42896H17H7.00001ZM10 6.42896H14V5.42896H10V6.42896ZM9 11.3333C9 10.8731 9.44772 10.5 10 10.5C10.5523 10.5 11 10.8731 11 11.3333V17.1667C11 17.6269 10.5523 18 10 18C9.44772 18 9 17.6269 9 17.1667V11.3333ZM13 11.3333C13 10.8731 13.4477 10.5 14 10.5C14.5523 10.5 15 10.8731 15 11.3333V17.1667C15 17.6269 14.5523 18 14 18C13.4477 18 13 17.6269 13 17.1667V11.3333Z"
          fill="currentColor"
        />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon name="OMQTrashIcon" {...props}>
      <path
        fill="currentColor"
        d="M.875 14c0 .963.788 1.75 1.75 1.75h7c.963 0 1.75-.787 1.75-1.75V3.5H.875V14zm1.75-8.75h7V14h-7V5.25zM9.188.875L8.312 0H3.939l-.876.875H0v1.75h12.25V.875H9.187z"
        transform="translate(-1150.000000, -293.000000) translate(460.000000, 0.000000) translate(40.000000, 285.000000) translate(650.000000, 8.000000) translate(5.875000, 4.125000)"
      />
    </SvgIcon>
  );
};

/**
 * Trash Icon with filled style.
 *
 * @param {SvgIconComponentProps} props - svg component props.
 *
 * @returns {JSX.Element}
 */
export const TrashFilledIcon = (props: SvgIconComponentProps): JSX.Element => {
  const name = useThemeName();

  if (name === Themes.USERLIKE) {
    return <TrashIcon {...props} />;
  }

  return (
    <SvgIcon name="OMQTrashFilledIcon" viewBox="0 0 56 56" {...props}>
      <path
        d="M16.071 42.889c0 2.261 1.865 4.111 4.143 4.111h16.572c2.278 0 4.143-1.85 4.143-4.111V18.222H16.07V42.89zM43 12.056h-7.25L33.679 10H23.32l-2.071 2.056H14v4.11h29v-4.11z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
